import gsap from 'gsap';
import { useGSAP } from '@gsap/react';
// import { useEffect, useRef, useState } from 'react';
// import { selectFirstLoading } from 'store/slices/UI-Slice';
// import { useSelector } from 'react-redux';


export const useAnimationForSVGBase = ({ pathsArray, imageIdsArray, container, isLoading = false }) => {

    useGSAP(() => {
        if (!isLoading) {

            const animatePaths = (pathRefsArray, imageIdsArray, arrayIndex = 0, index = 0, prevImageId = null, tweens = []) => {


                if (arrayIndex >= pathRefsArray.length || index >= pathRefsArray[arrayIndex].length) {
                    animatePaths(pathRefsArray, imageIdsArray);
                    return;
                }

                const pathRef = pathRefsArray[arrayIndex][index];
                const length = pathRef && pathRef.current ? pathRef.current.getTotalLength() : null;
                const imageId = imageIdsArray[arrayIndex][index];
                const hoverBg = document.querySelector(`#${imageId} .hoverBg`)
                const prevHoverBg = document.querySelector(`#${prevImageId} .hoverBg`)
                if (!length && length !== 0) {
                    gsap.to(`#${imageId}`, {
                        xPercent: -5,
                        yPercent: -5,
                        scale: 1.1,
                        duration: 0.5,
                        onComplete: () => {
                            if (index === pathRefsArray[arrayIndex].length - 1) {
                                gsap.to(`#${imageId}`, {
                                    xPercent: 0,
                                    yPercent: 0,
                                    scale: 1,
                                    duration: 0.5,
                                    onComplete: () => {
                                        animatePaths(pathRefsArray, imageIdsArray, arrayIndex + 1, 0, null);
                                    }
                                });
                                if (hoverBg) {
                                    gsap.to(hoverBg, {
                                        // fillOpacity: 0.1
                                        fillOpacity: 1,
                                        fill: "#a096e6"
                                    })
                                }

                            } else {
                                animatePaths(pathRefsArray, imageIdsArray, arrayIndex, index + 1, imageId, tweens);
                            }
                        }
                    });
                    if (hoverBg) {
                        gsap.to(`#${imageId} .hoverBg`, {
                            fillOpacity: 1,
                            fill: "#a096e6"
                        })
                    }
                    return;
                }

                gsap.fromTo(pathRef.current, {
                    strokeDasharray: length,
                    strokeDashoffset: 0
                }, {
                    strokeDasharray: 12,
                    strokeDashoffset: -length,
                    ease: "none",
                    duration: arrayIndex === 0 && index === 0 ? 2 : 1,
                    onComplete: () => {
                        const tween = gsap.to(pathRef.current, {
                            strokeDashoffset: -length * 2,
                            duration: 5,
                            ease: "none",
                            repeat: -1
                        });
                        tweens.push(tween);

                        if (prevImageId) {
                            gsap.to(`#${prevImageId}`, {
                                xPercent: 0,
                                yPercent: 0,
                                scale: 1,
                                duration: 0.5,
                            });
                            if (prevHoverBg) {
                                gsap.to(`#${prevImageId} .hoverBg`, {
                                    fillOpacity: 0.1
                                })
                            }

                        }

                        gsap.to(`#${imageId}`, {
                            xPercent: -5,
                            yPercent: -5,
                            scale: 1.1,
                            duration: 0.5,
                            onComplete: () => {
                                if (index === pathRefsArray[arrayIndex].length - 1) {
                                    gsap.to(`#${imageId}`, {
                                        xPercent: 0,
                                        yPercent: 0,
                                        scale: 1,
                                        duration: 0.5,
                                        onComplete: () => {
                                            tweens.forEach(tween => tween.kill());
                                            pathRefsArray[arrayIndex].forEach(pathRef => {
                                                if (pathRef && pathRef.current) {
                                                    const initialLength = pathRef.current.getTotalLength();
                                                    gsap.to(pathRef.current, {
                                                        strokeDasharray: 0,
                                                        strokeDashoffset: -initialLength * 1.5,
                                                        duration: 1,
                                                        ease: "none",
                                                    });
                                                }
                                            });
                                            animatePaths(pathRefsArray, imageIdsArray, arrayIndex + 1, 0, null);
                                        }
                                    });
                                    if (hoverBg) {
                                        gsap.to(`#${imageId} .hoverBg`, {
                                            fillOpacity: 0.1
                                        })
                                    }

                                } else {
                                    animatePaths(pathRefsArray, imageIdsArray, arrayIndex, index + 1, imageId, tweens);
                                }
                            }
                        });
                        if (hoverBg) {
                            gsap.to(`#${imageId} .hoverBg`, {
                                fillOpacity: 1,
                                fill: "#a096e6"
                            })
                        }
                    }
                });

            };


            animatePaths(pathsArray, imageIdsArray);
        }

    }, { dependencies: [isLoading], scope: container, revertOnUpdate: true });
};

export const useAnimatedPathDrawing = (pathsArray, pointArray, { container, isLoading = false, delayEven = 0 }) => {

    useGSAP(() => {
        let isForward = true;
        if (!isLoading) {


            const animatePathDrawing = (index) => {
                if (index >= pathsArray.length) {
                    resetAnimations();
                    animatePathDrawing(0);
                    return;
                }

                const point = pointArray[index];
                const pathObject = pathsArray[index];

                if (point === undefined || pathObject === undefined || pathObject === null) {
                    const nullPathId = setTimeout(() => {
                        animatePathDrawing(index + 1);
                    }, 1500);
                    return () => clearTimeout(nullPathId);
                }

                const [startId, endId] = point;
                const path = pathObject.current;


                if (!startId && !endId) {
                    animateLineDrawing(path, index);
                    return;
                }

                if (isForward) {
                    if (startId) {
                        gsap.fromTo(`#${startId}`, { opacity: 0 }, {
                            opacity: 1, duration: 0.3, onComplete: () => {
                                animateLineDrawing(path, index, startId, endId);
                            }
                        });
                    } else if (endId) {
                        gsap.fromTo(`#${endId}`, { opacity: 0 }, {
                            opacity: 1, duration: 0.3, onComplete: () => {
                                animateLineDrawing(path, index, startId, endId);
                            }
                        });
                    }
                } else {
                    if (startId) {
                        gsap.to(`#${startId}`, { opacity: 0, duration: 0.3 });
                    }
                    if (endId) {
                        gsap.to(`#${endId}`, { opacity: 0, duration: 0.3 });
                    }
                    animateLineDrawing(path, index, startId, endId);
                }
            };

            const animateLineDrawing = (path, index, startId, endId) => {
                if (path !== null) {
                    const length = path.getTotalLength();
                    gsap.fromTo(path, { strokeDashoffset: isForward ? length : 0, strokeDasharray: length }, {
                        strokeDashoffset: isForward ? 0 : length, duration: 0.7, ease: "power2.inOut", onComplete: () => {
                            if (isForward) {
                                if (endId) {
                                    gsap.fromTo(`#${endId}`, { opacity: 0 }, {
                                        opacity: 1, duration: 0.3, onComplete: () => {
                                            animatePathDrawing(index + 1);
                                        }
                                    });
                                } else {
                                    animatePathDrawing(index + 1);
                                }
                            } else {
                                animatePathDrawing(index + 1);
                            }
                        }
                    });
                }
            };

            const resetAnimations = () => {
                isForward = !isForward;
            };
            const animationDaley = setTimeout(() => {
                animatePathDrawing(0);
            }, delayEven);

            return () => clearTimeout(animationDaley);
        }
    }, { dependencies: [isLoading], scope: container, revertOnUpdate: true });
};

export const useAnimatedCountriesScale = ({ countryArray, container, isLoading = false }) => {
    useGSAP(() => {
        if (!isLoading) {

            if (!container.current) return;

            const evenCountries = [];
            const oddCountries = [];

            countryArray.forEach((country, index) => {
                if (index % 2 === 0) {
                    evenCountries.push(country);
                } else {
                    oddCountries.push(country);
                }
            });

            const tl = gsap.timeline({ repeat: -1 });

            evenCountries.forEach((country) => {
                tl.to(`#${country}`, {
                    scale: 1.2,
                    xPercent: -10,
                    yPercent: -10,
                    duration: 1,
                    ease: "power1.inOut",
                    yoyo: true,
                    repeat: -1,
                    yoyoEase: true,
                });
            });

            oddCountries.forEach((country) => {
                tl.to(`#${country}`, {
                    scale: 1.2,
                    xPercent: -10,
                    yPercent: -10,
                    duration: 1,
                    ease: "power1.inOut",
                    yoyo: true,
                    repeat: -1,
                    yoyoEase: true,
                });
            });

            return () => {
                tl.kill();
            };
        }

    }, { dependencies: [isLoading], scope: container, revertOnUpdate: true });
}


export const useAnimatedEthicallyScale = ({ ethicallyArray, container, isLoading = false }) => {
    useGSAP(() => {

        if (!container.current) return;

        const tl = gsap.timeline();

        ethicallyArray.forEach((subArray, index) => {
            const subTl = gsap.timeline({ delay: index * 0.1 });
            subArray.forEach((elementId) => {
                gsap.set(`#${elementId}`, { scale: 0, xPercent: 50, yPercent: 50 });
            });

            if (!isLoading) {
                subTl.to(subArray.map(elementId => `#${elementId}`), {
                    xPercent: 0,
                    yPercent: 0,
                    scale: 1,
                    duration: 0.5,
                    ease: "back.out(2.5)",
                }, "<");
            }
            tl.add(subTl);
        });

        return () => {
            tl.kill();
        };

    }, { dependencies: [isLoading], scope: container, revertOnUpdate: true });
}



export const useAnimatedSock5 = ({ lineArray, arrowArray, itemArray, container, isLoading = false }) => {
    let arrayIndex = 0;
    let lines = [];
    let arrows = [];
    let items = [];



    const animateIndex = (index) => {
        if (index >= lineArray.length) index = 0;

        lines.forEach(line => gsap.killTweensOf(line));
        arrows.forEach(arrow => gsap.killTweensOf(arrow));
        items.forEach(item => gsap.killTweensOf(item));

        lines = lineArray[index].map(lineId => document.getElementById(lineId)).filter(Boolean);
        arrows = arrowArray[index].map(arrowId => document.getElementById(arrowId)).filter(Boolean);
        items = itemArray[index].map(itemId => document.getElementById(itemId)).filter(Boolean);

        lines.forEach(line => {
            const length = line.getTotalLength();
            gsap.set(line, { strokeDasharray: length, strokeDashoffset: length });
            gsap.to(line, { strokeDashoffset: 0, duration: 0.5, onComplete: onCompleteLineAnimation });
        });
    };

    const onCompleteLineAnimation = () => {
        arrows.forEach(arrow => {
            const length = arrow.getTotalLength();
            gsap.set(arrow, { strokeDasharray: length, strokeDashoffset: length, opacity: 0 });
            gsap.to(arrow, { strokeDashoffset: 0, duration: 0.15, opacity: 1, onComplete: onCompleteArrowAnimation });
        });
    };

    const onCompleteArrowAnimation = () => {
        items.forEach(item => {
            gsap.to(item.querySelectorAll('.bg'), { fill: '#5547eb', duration: 0.5 });
            gsap.to(item.querySelectorAll('.icone'), { fill: '#fff', duration: 0.5, onComplete: onCompleteItemAnimationReverse });
        });
    };

    const onCompleteItemAnimationReverse = () => {
        items.forEach(item => {
            gsap.to(item.querySelectorAll('.bg'), { fill: '#fff', duration: 0.3, delay: 0.5 });
            gsap.to(item.querySelectorAll('.icone'), { fill: '#A192EC', duration: 0.3, delay: 0.5, onComplete: onCompleteArrowAnimationReverse });
        });
    };

    const onCompleteArrowAnimationReverse = () => {
        arrows.forEach(arrow => {
            const length = arrow.getTotalLength();
            gsap.to(arrow, { strokeDashoffset: length, duration: 0.15, opacity: 0, onComplete: onCompleteLinesAnimationReverse });
        });
    };

    const onCompleteLinesAnimationReverse = () => {
        lines.forEach(line => {
            const length = line.getTotalLength();
            gsap.fromTo(line, { strokeDashoffset: 0 }, {
                strokeDashoffset: length, duration: 0.5, onComplete: () => {
                    arrayIndex++;
                    if (arrayIndex >= lineArray.length) {
                        arrayIndex = 0;
                    }
                    animateIndex(arrayIndex);
                }
            });
        });
    };

    useGSAP(() => {
        if (!isLoading) {
            animateIndex(0);
        }
    }, { dependencies: [isLoading], scope: container, revertOnUpdate: true });
};


export const useAnimatedNetwork = ({ ethicallyArray, container, isLoading = false }) => {

    useGSAP(() => {
        if (!isLoading) {

            if (!container.current) return;

            const tl = gsap.timeline();

            ethicallyArray.forEach((subArray, index) => {
                const subTl = gsap.timeline({ delay: 0.5 });
                subArray.forEach((elementId) => {
                    gsap.set(`#${elementId}`, { scale: 0, xPercent: 50, yPercent: 50 });
                    subTl.to(`#${elementId}`, {
                        xPercent: 0,
                        yPercent: 0,
                        scale: 1,
                        duration: 0.5,
                        ease: "power1.inOut",
                    });
                });
                tl.add(subTl);
            });

            return () => {
                tl.kill();
            };
        }

    }, { dependencies: [isLoading], scope: container, revertOnUpdate: true });
}